import Vue from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import $ from 'jquery';
import longClick from './directives/longclick'

export const longClickDirective = longClick
window.$ = window.jQuery = $;
//require('./vendors/iframe.js');

Vue.config.productionTip = false;
const longClickInstance = longClickDirective({delay: 400, interval: 50})
Vue.directive('longclick', longClickInstance)

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app');
